import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CheckInIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CheckInIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M18.335 22H5.66519C4.20016 22 3.0083 20.8081 3.0083 19.3431V18.5136C3.0083 18.2315 3.2366 18.0032 3.51874 18.0032C3.80088 18.0032 4.02918 18.2315 4.02918 18.5136V19.3431C4.02918 20.2454 4.76294 20.9791 5.66519 20.9791H18.335C19.2372 20.9791 19.971 20.2454 19.971 19.3431V6.46886C19.971 5.56662 19.2372 4.83286 18.335 4.83286H5.66519C4.76294 4.83286 4.02918 5.56662 4.02918 6.46886V11.0613C4.02918 11.3435 3.80088 11.5718 3.51874 11.5718C3.2366 11.5718 3.0083 11.3435 3.0083 11.0613V6.46886C3.0083 5.00384 4.20016 3.81198 5.66519 3.81198H18.335C19.8 3.81198 20.9919 5.00384 20.9919 6.46886V19.3431C20.9919 20.8081 19.8 22 18.335 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4321 9.71096H3.56809C3.28595 9.71096 3.05765 9.48266 3.05765 9.20052C3.05765 8.91838 3.28595 8.69008 3.56809 8.69008H20.4321C20.7142 8.69008 20.9425 8.91838 20.9425 9.20052C20.9425 9.48266 20.7142 9.71096 20.4321 9.71096Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.87145 6.64432C7.58931 6.64432 7.36101 6.41602 7.36101 6.13388V2.51044C7.36101 2.2283 7.58931 2 7.87145 2C8.15359 2 8.38189 2.2283 8.38189 2.51044V6.13388C8.38189 6.41602 8.15359 6.64432 7.87145 6.64432Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1292 6.64432C15.8471 6.64432 15.6188 6.41602 15.6188 6.13388V2.51044C15.6188 2.2283 15.8471 2 16.1292 2C16.4114 2 16.6397 2.2283 16.6397 2.51044V6.13388C16.6397 6.41602 16.4114 6.64432 16.1292 6.64432Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.39031 17.0431C9.25971 17.0431 9.12911 16.9932 9.02941 16.8935C8.83002 16.6941 8.83002 16.3711 9.02941 16.1717L10.8867 14.3144L9.02941 12.4571C8.83002 12.2577 8.83002 11.9347 9.02941 11.7353C9.2288 11.5359 9.55181 11.5359 9.7512 11.7353L11.9694 13.9535C12.1688 14.1529 12.1688 14.4759 11.9694 14.6753L9.7512 16.8935C9.6515 16.9932 9.52091 17.0431 9.39031 17.0431Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.6085 14.8249H5.22103C4.93889 14.8249 4.71059 14.5966 4.71059 14.3144C4.71059 14.0323 4.93889 13.804 5.22103 13.804H11.6085C11.8907 13.804 12.119 14.0323 12.119 14.3144C12.119 14.5966 11.8907 14.8249 11.6085 14.8249Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CheckInIcon;
